import { parseISO, startOfDay } from "date-fns"
import { makeAutoObservable, runInAction } from "mobx"
import { FIRESTORE_COLLECTIONS } from "../enums"
import { IEventCollectionItem } from "../interfaces"
import Firestore from "../services/FirestoreService"

export class EventStore {
	upcomingEvents: IEventCollectionItem[] | null = null
	pastEvents: IEventCollectionItem[] | null = null
	isLoading = false
	error: Error | null = null

	constructor() {
		makeAutoObservable(this)
	}

	async load(): Promise<void> {
		this.pastEvents = null
		this.upcomingEvents = null
		this.isLoading = true

		let events: IEventCollectionItem[]
		let error: Error | null = null

		const todaysDate: string = new Date().toISOString().substring(0, 10)

		try {
			events = await Firestore.query<IEventCollectionItem>(FIRESTORE_COLLECTIONS.EVENTS_COLLECTION)
		} catch (err) {
			error = err as Error
		}

		runInAction(() => {
			this.upcomingEvents = events.filter((event) => startOfDay(parseISO(event.start)) >= startOfDay(parseISO(todaysDate)))
			this.pastEvents = events.filter((event) => startOfDay(parseISO(event.start)) < startOfDay(parseISO(todaysDate)))
			this.isLoading = false
			this.error = error
		})
	}
}
